(function(){
  const header=document.querySelector('[data-header]');
  window.addEventListener('scroll',()=>{if(header)header.classList.toggle('scrolled',window.scrollY>40)},{passive:true});
  const toggle=document.querySelector('[data-menu-toggle]'),menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu)toggle.addEventListener('click',()=>menu.classList.toggle('open'));
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-visible')}),{threshold:.12});
  document.querySelectorAll('[data-reveal]').forEach(el=>{el.classList.add('reveal');observer.observe(el)});
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce && window.matchMedia('(pointer:fine)').matches){
    document.querySelectorAll('.tilt-card').forEach(card=>{
      card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`perspective(900px) rotateX(${(-y*4).toFixed(2)}deg) rotateY(${(x*5).toFixed(2)}deg) translateZ(4px)`});
      card.addEventListener('pointerleave',()=>card.style.transform='');
    });
    const hero=document.querySelector('[data-hero]');
    hero&&hero.addEventListener('pointermove',e=>{const x=(e.clientX/innerWidth-.5),y=(e.clientY/innerHeight-.5);const media=hero.querySelector('[data-hero-media]');if(media)media.style.transform=`scale(1.055) translate(${x*-8}px,${y*-6}px)`});
  }
})();
